import {z as zod} from "zod";

export type DomainAggregateWorkspaceCapabilityConfiguration = Record<string, never>;

export const domainAggregateWorkspaceCapabilityConfigurationValidator: zod.ZodType<DomainAggregateWorkspaceCapabilityConfiguration> = zod.strictObject({});
